var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQueueUmum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 225,
    viewBox: "0 0 281 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_28)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.882 48.9371C202.418 45.5518 199.439 42.573 196.053 40.1089C185.46 32.0833 170.452 32.0833 140.356 32.0833C110.259 32.0833 95.2516 32.0833 84.6577 40.1089C81.2653 42.5917 78.2628 45.5672 75.7494 48.9371C68.1251 59.5309 68.125 74.5388 68.125 104.635V120.686C68.125 150.782 68.1251 165.87 75.7494 176.384C78.2394 179.797 81.2446 182.802 84.6577 185.292C95.2516 192.917 110.259 192.917 140.356 192.917C170.452 192.917 185.46 192.917 196.053 185.292C199.46 182.822 202.442 179.813 204.882 176.384C212.907 165.87 212.907 150.782 212.907 120.686V104.635C212.586 74.8599 212.586 59.5309 204.882 48.9371ZM140.677 52.5487C143.852 52.5487 146.955 53.49 149.594 55.2538C152.234 57.0175 154.291 59.5243 155.506 62.4573C156.721 65.3903 157.039 68.6177 156.419 71.7313C155.8 74.8449 154.271 77.705 152.027 79.9498C149.782 82.1946 146.922 83.7234 143.808 84.3427C140.694 84.962 137.467 84.6441 134.534 83.4293C131.601 82.2144 129.094 80.1571 127.331 77.5175C125.567 74.8778 124.626 71.7745 124.626 68.5999C124.625 64.3979 126.271 60.3631 129.213 57.362C132.154 54.3608 136.154 52.6327 140.356 52.5487H140.677ZM130.565 89.627H150.789C155.046 89.627 159.129 91.3181 162.139 94.3283C165.149 97.3385 166.84 101.421 166.84 105.678C166.84 109.935 165.149 114.018 162.139 117.028C159.129 120.038 155.046 121.729 150.789 121.729H130.565C126.307 121.729 122.225 120.038 119.214 117.028C116.204 114.018 114.513 109.935 114.513 105.678C114.513 101.421 116.204 97.3385 119.214 94.3283C122.225 91.3181 126.307 89.627 130.565 89.627ZM134.658 172.772H109.698C108.102 172.772 106.571 172.138 105.442 171.009C104.313 169.881 103.679 168.35 103.679 166.753C103.679 165.157 104.313 163.626 105.442 162.497C106.571 161.368 108.102 160.734 109.698 160.734H134.658C136.254 160.734 137.785 161.368 138.914 162.497C140.043 163.626 140.677 165.157 140.677 166.753C140.677 168.35 140.043 169.881 138.914 171.009C137.785 172.138 136.254 172.772 134.658 172.772V172.772ZM171.656 146.127H109.698C108.102 146.127 106.571 145.493 105.442 144.364C104.313 143.236 103.679 141.704 103.679 140.108C103.679 138.512 104.313 136.981 105.442 135.852C106.571 134.723 108.102 134.089 109.698 134.089H171.656C173.252 134.089 174.783 134.723 175.912 135.852C177.041 136.981 177.675 138.512 177.675 140.108C177.675 141.704 177.041 143.236 175.912 144.364C174.783 145.493 173.252 146.127 171.656 146.127Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_28",
    x: 53.125,
    y: 24.0833,
    width: 174.782,
    height: 190.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308611 0 0 0 0 0.453017 0 0 0 0 0.733333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_28"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_28",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 193,
    fill: "white",
    transform: "translate(44 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQueueUmum);
export default __webpack_public_path__ + "static/media/icon_queue_umum.7366daaf7546accc0975c2df924a7c63.svg";
export { ForwardRef as ReactComponent };